import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Admission from "@/pages/admission/page";
import Classes from "@/pages/classes/page";
import Schedule from "@/pages/schedule/page";
import About from "@/pages/about/page";
import Consult from "@/pages/consult/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "admission",
        element: <Admission />,
      },
      {
        path: "classes",
        element: <Classes />,
      },
      {
        path: "schedule",
        element: <Schedule />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "consult",
        element: <Consult />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;